module.exports = "pegasus_template/assets/blocks/capture-12-basic.png";